// init slick-slider with isotop
export function slider(Isotope) {
    return function slider() {
        let sliders = (() => {
            let iso;
            let isoGrid = "js-iso-layout";
            let initilizedIsotop = "is-isotop-inited";
            let slider = $(".js-slider");
            let initilizedClass = "is-inited";
            let mobileClass = "js-slider-mob";
            let mobileResolution = this.mobile;
            let options = {
                dots: true,
                autoplaySpeed: 5000,
                adaptiveHeight: true,
                arrows: true,
                draggable: false,
                nextArrow: "<button class='slick-next slick-arrow'><i class='icon icon-long-arrow-right'></i></button>",
                prevArrow: "<button class='slick-prev slick-arrow'><i class='icon icon-long-arrow-right'></i></button>",
            };
            let optIso = {
                layoutMode:"packery",
                packery: {gutter: 0},
                itemSelector: ".js-iso-layout-item",
                percentPosition: !0
            };
            let initIsotope = () => {
                if($(".js-iso-layout").length) {
                    iso = new Isotope( ".js-iso-layout", optIso);
                    $(".js-iso-layout").addClass("is-isotop-inited");
                }
            };
            let destroyIsotope = () => {
                if($(".js-iso-layout").length) {
                    iso.destroy();
                    $(".js-iso-layout").removeClass(initilizedIsotop);
                }
            };
            let destroySlider = obj => {
                obj.slick("unslick");
            };
            let initActions = (item) => {
                item.on("init", function (event, slick) {
                    $(slick.$slider).addClass(initilizedClass);
                });
                item.slick(options);
                item.on("destroy", function (event, slick) {
                    $(slick.$slider).removeClass(initilizedClass);
                });
                if(item.closest(".intro").length) {
                    item.slick("slickSetOption", "autoplay", true, true);
                    item.slick("slickSetOption", "adaptiveHeight", true, true);
                }
                if(item.closest(".introduce-block").length) {
                    item.slick("slickSetOption", "autoplay", true, true);
                }
            };
            let inspectionResolution = (mobile, item) => {
                let isMobileResolution = window.innerWidth < mobileResolution;
                let isSliderForMobile = mobile;
                let isSliderInitilized = item.hasClass(initilizedClass);
                if (isMobileResolution && isSliderForMobile && !isSliderInitilized) {
                    if (item.hasClass(isoGrid) && item.hasClass(initilizedIsotop)) {
                        // destroy isotope grid
                        destroyIsotope();
                    }
                    initActions(item);
                } else if (!isMobileResolution && isSliderForMobile && isSliderInitilized) {
                    destroySlider(item);
                    // initilize izotope grid
                    if (item.hasClass(isoGrid) && !item.hasClass(initilizedIsotop)) {
                        initIsotope();
                    }
                } else if (!isSliderForMobile && !isSliderInitilized) {
                    initActions(item);
                }
            };
            let initAllSliders = () => {
                slider.each((index, item) => {
                    let isSliderForMobile = $(item).hasClass(mobileClass);
                    inspectionResolution(isSliderForMobile, $(item));
                });
            };
            let fullInit = () => {
                initAllSliders();
                window.addEventListener("resize", () => {
                    setTimeout(() => {
                        initAllSliders();
                    }, 300);
                });
                if(window.innerWidth >= mobileResolution) {
                    initIsotope();
                }
            };

            return fullInit;

        })();
        sliders();
    };
}


// WEBPACK FOOTER //
// ./assets/js/modules/slider&isotop.js